
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/short-internships",
      function () {
        return require("private-next-pages/next/short-internships/index.tsx");
      }
    ]);
  